(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateDeleteController',DiscountRateDeleteController);

    DiscountRateDeleteController.$inject = ['$uibModalInstance', 'entity', 'DiscountRate'];

    function DiscountRateDeleteController($uibModalInstance, entity, DiscountRate) {
        var vm = this;
        vm.discountRate = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DiscountRate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
